var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center border border-gray-600 rounded overflow-hidden bg-neutral-800 w-full"},[_c('button',{class:_vm.noButtonClasses,on:{"click":_vm.selectNo}},[_vm._v(" No ")]),_c('div',{staticClass:"border-l border-gray-600"}),_vm._v(" "),_c('button',{class:_vm.yesButtonClasses,on:{"click":_vm.selectYes}},[_vm._v(" Yes ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }